import App from './App.vue';

export default {
  path: '/CDS_VF_LifelineWaterDetail',
  name: 'CDS_VF_LifelineWaterDetail',
  component: App,
  meta: {
    pageProperty: {
      title: 'ライフライン(水道・下水)',
      controller: 'CDS_CTR_LifelineWaterDetail',
    },
  },
};
